import React from "react";
import { useObservableValue } from "@iventis/utilities";
import { Session, SessionComponent } from "./types";
import { useShowSubEvents } from "./hooks";
import { SessionBrief } from "./session-brief";
import { SessionDetailed } from "./session-detailed";

interface CalendarSessionProps {
    session: Session;
    sessionComponent: SessionComponent;
    eventUnitComponent: SessionComponent;
    sessionTabFormatter?: (session: Session) => string;
    onClick?: (session: Session, event: PointerEvent) => void;
    onContextClick?: (session: Session, event: PointerEvent) => void;
}

export const CalendarSession: React.FC<CalendarSessionProps> = React.memo(({ session, sessionComponent, eventUnitComponent, onClick, onContextClick, sessionTabFormatter }) => {
    const showSubEvents$ = useShowSubEvents();
    const showSubEvents = useObservableValue(showSubEvents$);

    return (
        <>
            {showSubEvents ? (
                <SessionDetailed
                    session={session}
                    sessionTabFormatter={sessionTabFormatter}
                    sessionComponent={sessionComponent}
                    eventUnitComponent={eventUnitComponent}
                    onClick={onClick}
                    onContextClick={onContextClick}
                />
            ) : (
                <SessionBrief session={session} sessionComponent={sessionComponent} onClick={onClick} onContextClick={onContextClick} />
            )}
        </>
    );
});
